import { AppServices, registerAppServices } from 'conversations/services'
import { getIpcService } from 'conversations/services/desktopAppServices/ipc'
import { registerNotificationListeners } from 'conversations/services/desktopAppServices/notificationService'
import config from 'shared/config'
import { IpcChannel } from 'shared/ipc/IpcChannel'
import { ConversationNotification } from 'shared/notifications/ConversationNotification'
import { onElectronFocus } from 'shared/store/actions/platform'

import { GlobalStore as store } from '@driftt/traffic-control'
import { clearIdentityInfo, deleteAccessToken, getAccessToken } from '@driftt/web-auth'

import { RootAction } from 'typesafe-actions'

import { registerNavigationListeners } from './desktopAppServices/navigation'

const desktopAppServices: AppServices = {
  notifications: {
    sendNotification: (notif: ConversationNotification): Promise<void> =>
      getIpcService().request<any, any>(IpcChannel.SEND_CONVERSATION_NOTIFICATION, notif),
  },
  badges: {
    showBadgeIconNumber: (numberOfUnreadConversations: number): Promise<void> =>
      getIpcService().request<any, any>(
        IpcChannel.SHOW_BADGE_ICON_NUMBER,
        numberOfUnreadConversations
      ),
    isWindowVisible: (): Promise<boolean> => {
      return getIpcService().request<any, any>(IpcChannel.GET_WINDOW_VISIBLE)
    },
  },
  auth: {
    openWebLogin: () => {
      clearIdentityInfo(getAccessToken())
      deleteAccessToken()
      const redirectUrl = `drift://${config.BASE_DOMAIN}/conversations`
      const encodedRedirectUrl = encodeURIComponent(redirectUrl)
      const fullLoginUrl = `${config.LOGIN_URL}?redirect=${encodedRedirectUrl}&client=${config.CLIENT_ID}`
      window.location.assign(fullLoginUrl)
    },
    logout: () => {
      clearIdentityInfo(getAccessToken())
      deleteAccessToken()
      window.location.href = '#/conversations/welcome?forceRefresh=true'
    },
  },
  util: {
    log: (entry: any) => getIpcService().request<any, void>(IpcChannel.LOG, entry),
  },
  reload: {
    reloadApplication: () => window.location.reload(),
  },
  redux: {
    sendAction: (action: RootAction) => getIpcService().send('redux-action', action),
  },
}

export const registerDesktopAppServices = (): void => {
  registerNotificationListeners()
  registerAppServices(desktopAppServices)
  registerNavigationListeners()

  getIpcService().listen(IpcChannel.ON_FOCUS, () => {
    store.dispatch(onElectronFocus())
  })

  getIpcService().listen('redux-action', (_, data) => store.dispatch(data))
}
